<template>
  <div class="py-5" style="padding-inline: 5%">
    <h2 class="font-montserrat-b text-center mb-4">{{ $t('prices.title')}}</h2>
    <h3 class="font-montserrat-sb text-center mb-5">{{ $t('prices.price-title')}}</h3>

    <div class="row gx-5 justify-content-center">
      <div
        v-for="(item, index) of plans"
        :key="index"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex align-items-stretch"
        data-aos="flip-left"
      >
        <PriceCard
          :item="item"
          :select-language="selectLanguage"
        />
      </div>
    </div>

  </div>
</template>

<script>
import { useAppStore } from '@/stores/app'
import { computed } from 'vue'
import PriceCard from './PriceCard.vue'

export default {
  components: {
    PriceCard
  },
  setup() {

    /*
    const prices = [
      {
        name: 'price-name-one',
        description: 'price-desc-one',
        price: 299,
        bestSeller: false,
        items: [
          {
            text: {
              en: 'Live Video Training or Auditing',
              es: 'Formación o auditoría por vídeo en directo',
              pt: 'Formação ou Auditoria em vídeo ao vivo'
            },
            cost: '$60-per-hour'
          },
          {
            text: {
              en: 'Additional Consulting',
              es: 'Consultoria adicional',
              pt: 'Consultoria adicional'
            },
            cost: '$60-per-hour'
          },
          {
            text: {
              en: 'On Site Auditing, training and facility reviews',
              es: 'Auditoría en sitio, revisión de las capacitaciones e instalaciones.',
              pt: 'Auditoria no local, formação ou revisão de instalações'
            },
            cost: '$1000-per-day'
          },
        ],
        benefits: [
          {
            title: 'itemOne',
            check: true,
          },
          {
            title: 'itemTwo',
            check: true,
          },
          {
            title: 'itemThree',
            check: true,
          },
          {
            title: 'itemFive',
            check: true,
          },
        ]
      },
      {
        name: 'price-name-two',
        description: 'price-desc-two',
        price: 599,
        bestSeller: false,
        items: [
          {
            text: {
              en: 'Live Video Training or Auditing',
              es: 'Formación o auditoría por vídeo en directo',
              pt: 'Formação ou Auditoria em vídeo ao vivo'
            },
            cost: '$45-per-hour'
          },
          {
            text: {
              en: 'Additional Consulting',
              es: 'Consultoria adicional',
              pt: 'Consultoria adicional'
            },
            cost: '$45-per-hour'
          },
          {
            text: {
              en: 'On Site Auditing, training and facility reviews',
              es: 'Auditoría en sitio, revisión de las capacitaciones e instalaciones.',
              pt: 'Auditoria no local, formação ou revisão de instalações'
            },
            cost: '$500-per-day'
          },
        ],
        benefits: [
          {
            title: 'itemOne',
            check: true,
          },
          {
            title: 'itemTwo',
            check: true,
          },
          {
            title: 'itemThree',
            check: true,
          },
          {
            title: 'itemFour',
            check: true,
          },
          {
            title: 'itemFive',
            check: true,
          },
          {
            title: 'itemSix',
            check: true,
          },
          {
            title: 'itemSeven',
            check: true,
          },
          {
            title: 'itemEight',
            check: true,
          },
          {
            title: 'itemNine',
            check: true,
          },
          {
            title: 'itemTwelve',
            check: true,
          },
        ]
      },
      {
        name: 'price-name-three',
        description: 'price-desc-three',
        price: 899,
        bestSeller: true,
        items: [
          {
            text: {
              en: 'Live Video Training or Auditing',
              es: 'Formación o auditoría por vídeo en directo',
              pt: 'Formação ou Auditoria em vídeo ao vivo'
            },
            cost: '$30-per-hour'
          },
          {
            text: {
              en: 'Additional Consulting',
              es: 'Consultoria adicional',
              pt: 'Consultoria adicional'
            },
            cost: '$30-per-hour'
          },
          {
            text: {
              en: 'On Site Auditing, training and facility reviews',
              es: 'Auditoría en sitio, revisión de las capacitaciones e instalaciones.',
              pt: 'Auditoria no local, formação ou revisão de instalações'
            },
            cost: '1-day-free'
          },
        ],
        benefits: [
          {
            title: 'itemOne',
            check: true,
          },
          {
            title: 'itemTwo',
            check: true,
          },
          {
            title: 'itemThree',
            check: true,
          },
          {
            title: 'itemFour',
            check: true,
          },
          {
            title: 'itemFive',
            check: true,
          },
          {
            title: 'itemSix',
            check: true,
          },
          {
            title: 'itemSeven',
            check: true,
          },
          {
            title: 'itemEight',
            check: true,
          },
          {
            title: 'itemNine',
            check: true,
          },
          {
            title: 'itemTen',
            check: true,
          },
          {
            title: 'itemEleven',
            check: true,
          },
          {
            title: 'itemTwelve',
            check: true,
          },
        ]
      },
      {
        name: 'price-name-fourth',
        description: 'price-desc-fourth',
        price: 'price-esmerald-plus',
        contactForPrice: true,
        bestSeller: true,
        items: [
          {
            text: {
              en: 'Live Video Training or Auditing',
              es: 'Formación o auditoría por vídeo en directo',
              pt: 'Formação ou Auditoria em vídeo ao vivo'
            },
            cost: 'special-price'
          },
          {
            text: {
              en: 'Additional Consulting',
              es: 'Consultoria adicional',
              pt: 'Consultoria adicional'
            },
            cost: 'special-price'
          },
          {
            text: {
              en: 'On Site Auditing, training and facility reviews',
              es: 'Auditoría en sitio, revisión de las capacitaciones e instalaciones.',
              pt: 'Auditoria no local, formação ou revisão de instalações'
            },
            cost: '2-day-free'
          },
        ],
        benefits: [
          {
            title: 'itemOne',
            check: true,
          },
          {
            title: 'itemTwo',
            check: true,
          },
          {
            title: 'itemThree',
            check: true,
          },
          {
            title: 'itemFour',
            check: true,
          },
          {
            title: 'itemFive',
            check: true,
          },
          {
            title: 'itemSix',
            check: true,
          },
          {
            title: 'itemSeven',
            check: true,
          },
          {
            title: 'itemEight',
            check: true,
          },
          {
            title: 'itemNine',
            check: true,
          },
          {
            title: 'itemTen',
            check: true,
          },
          {
            title: 'itemEleven',
            check: true,
          },
          {
            title: 'itemTwelve',
            check: true,
          },
        ]
      },
    ]
    */

    const app = useAppStore()

    const selectLanguage = computed(() => {
      return app.language
    })
    const plans = computed(() => app.plans);

    return {
      plans,
      selectLanguage
    }
  },
}
</script>
